import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "practice-history",
  "aria-label": "このレッスンのAI練習"
}
const _hoisted_2 = { class: "history-toolbar" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = {
  key: 0,
  class: "history-content"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "history-list"
}
const _hoisted_7 = { class: "history-meta" }
const _hoisted_8 = ["aria-label", "onClick"]
const _hoisted_9 = {
  key: 2,
  role: "alert"
}
const _hoisted_10 = {
  key: 3,
  role: "status"
}

import { onBeforeUnmount, ref, watch } from 'vue'
import LessonPracticeApi, { PracticeHistoryItem } from '../../../api/v2/api/lesson_practice'

export default /*@__PURE__*/_defineComponent({
  __name: 'LessonPracticeHistory',
  props: {
    lessonId: {},
    courseId: {},
    refreshKey: {},
    artifactVisible: { type: Boolean }
  },
  emits: ["open", "latest"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const api = new LessonPracticeApi()
const expanded = ref(false), loading = ref(false), error = ref('')
const items = ref<PracticeHistoryItem[]>([]), nextCursor = ref<number | null>(null)
const latest = ref<PracticeHistoryItem | null>(null)
let revision = 0
onBeforeUnmount(() => { revision++ })
async function load(older: boolean) {
  const token = ++revision
  loading.value = true; error.value = ''
  try {
    const result = await api.history(props.lessonId, older ? nextCursor.value || undefined : undefined, props.courseId)
    if (token !== revision) return
    // Replace the visible page instead of accumulating an unlimited list.
    items.value = result.items
    nextCursor.value = result.nextCursor
    if (!older) { latest.value = result.items[0] || null; if (latest.value) emit('latest', { examId: latest.value.examId }) }
  } catch { if (token === revision) error.value = '練習履歴を読み込めませんでした。' }
  finally { if (token === revision) loading.value = false }
}
function open(item: PracticeHistoryItem) { emit('open', { examId: item.examId }); expanded.value = false }
function date(value: string) { return new Date(value).toLocaleString('ja-JP', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }
function status(item: PracticeHistoryItem) { return { ready: '未着手', started: '取り組み中', finished: '提出済み' }[item.status] }
watch(() => [props.lessonId, props.courseId, props.refreshKey], () => { items.value = []; latest.value = null; nextCursor.value = null; load(false) }, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (latest.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "history-label" }, "このレッスンのAI練習", -1 /* CACHED */)),
          (latest.value && !__props.artifactVisible)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (open(latest.value)))
              }, _toDisplayString(latest.value.status === 'finished' ? '前回の練習を振り返る' : '前回の練習を続ける') + " →", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            type: "button",
            "aria-expanded": expanded.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = !expanded.value))
          }, _toDisplayString(expanded.value ? '履歴を閉じる' : '練習履歴'), 9 /* TEXT, PROPS */, _hoisted_3)
        ]),
        (expanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "history-note" }, "あなたとAIの会話から作った練習です。マイテストには並べず、この教材に履歴を残します。", -1 /* CACHED */)),
              (!loading.value && !items.value.length && !error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "まだ練習はありません。チャットで理解度を確認してから作成できます。"))
                : _createCommentVNode("v-if", true),
              (items.value.length)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.userExamId
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_7, [
                            _createTextVNode(_toDisplayString(date(item.createdAt)) + " · " + _toDisplayString(status(item)), 1 /* TEXT */),
                            (item.score != null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(Math.round(item.score)) + "%", 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("strong", null, _toDisplayString(item.title), 1 /* TEXT */),
                          _createElementVNode("p", null, _toDisplayString(item.focus), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          "aria-label": `${item.title}を${item.status === 'finished' ? '振り返る' : '開く'}`,
                          onClick: ($event: any) => (open(item))
                        }, _toDisplayString(item.status === 'finished' ? '振り返る' : '開く'), 9 /* TEXT, PROPS */, _hoisted_8)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createTextVNode(_toDisplayString(error.value) + " ", 1 /* TEXT */),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (load(false)))
                    }, "読み直す")
                  ]))
                : _createCommentVNode("v-if", true),
              (loading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "履歴を読み込んでいます…"))
                : _createCommentVNode("v-if", true),
              (items.value.length && latest.value && items.value[0].userExamId !== latest.value.userExamId && !loading.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (load(false)))
                  }, "最新の練習に戻る"))
                : _createCommentVNode("v-if", true),
              (nextCursor.value && !loading.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (load(true)))
                  }, "前の10件を表示"))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})